/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 300,
    height: 300,
    viewBox: '0 0 225 225',
    data: '<path pid="0" d="M100 3.1c-25.9 3-48.9 14.5-67.1 33.6-40.7 42.7-40.7 108.9 0 151.6 21.4 22.4 48.6 34.1 79.6 34.1 29.9 0 56.4-11.1 77.6-32.3 31.6-31.6 40.9-77.4 24-119.5-12.5-31.2-41.1-56.2-74-64.6-8-2.1-23.2-4.1-29.1-3.9-1.9.1-6.9.5-11 1zm39.3 13.3c17.4 5.2 30.9 13.1 43.2 25.3C193.9 53 203.4 68.4 207.8 83c6.9 22.6 5.3 48.8-4.3 70.5-9.2 20.8-30.2 41.5-51.2 50.4-15.1 6.5-21.1 7.6-40.3 7.5-16.1 0-18.2-.2-26.3-2.7-36-11.1-60.1-36-70.3-72.7-2.9-10.3-2.7-37.6.4-49 8.7-32.3 34.1-59 65.8-69.4 11.7-3.8 17.6-4.6 33.4-4.2 13.2.3 16.8.7 24.3 3z"/><path pid="1" d="M82 111.1v46l7.3-4.1c3.9-2.2 22.1-12.2 40.4-22.2 18.2-10.1 33.1-18.3 33-18.4-.1-.1-18.3-10.8-40.4-23.7L82 65.2v45.9z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/dist/icons/play.js